export var checkHasMissingResources = function (path) { return function (action$, state$, deps) {
    var missingResources = action$.missingResources;
    if (missingResources && missingResources.missingResources.length > 0) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/checks/checkHasMissingResources.ts
// module id = 2098
// module chunks = 3